import * as yup from 'yup'

export default yup.object().shape({
  newPassword: yup
    .string()
    .required()
    .matches(/^(?=.{8,})/, 'Must at least 8 characters long')
    .matches(/^(?=.*[0-9])/, 'Must contain one number')
    .matches(/^(?=.*[a-z])/, 'Must contain one lowercase letter')
    .matches(/^(?=.*[A-Z])/, 'Must contain one uppercase letter')
    .matches(
      /^(?=.*[!@#$%^&*()-])/,
      'Must contain a special character (!@#$%^&*()-)',
    )
    .label('New password'),
  newPasswordConf: yup
    .string()
    .required()
    .oneOf([yup.ref('newPassword'), null], 'Passwords must match')
    .label('Password confirmation'),
})
